import React from 'react'
import { Download } from 'lucide-react'
import { useI18n } from '../../i18n'
import { Button } from '../ui'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

export type PolicyVersionRow = {
  id: string
  version: string
  fileName?: string | null
  createdAt: string
  createdBy?: string | null
  status?: string | null
  changeNote?: string | null
  effectiveFrom?: string | null
  nextReviewAt?: string | null
}

type Props = {
  policyId: string
  versions: PolicyVersionRow[]
  onDownload: (policyId: string, versionId: string) => void
}

export function PolicyDocumentVersionHistory({ policyId, versions, onDownload }: Props) {
  const { t } = useI18n()
  if (!versions?.length) {
    return (
      <p className="text-sm text-muted-foreground">
        {t('governance.documentLifecycle.noVersions', 'No versions yet')}
      </p>
    )
  }

  return (
    <ul className="space-y-2 text-sm">
      {versions.map((v) => (
        <li key={v.id} className="flex flex-wrap items-center gap-2 justify-between">
          <span>
            <strong>{v.version}</strong>
            {' — '}
            {new Date(v.createdAt).toLocaleDateString()}
            {v.status ? ` — ${v.status}` : ''}
            {v.fileName ? ` — ${v.fileName}` : ''}
          </span>
          <Button
            type="button"
            size="small"
            color="outline"
            icon={<Download className={listStyles.badgeIcon} aria-hidden />}
            onClick={() => onDownload(policyId, v.id)}
          >
            {t('governance.documentLifecycle.downloadVersion', 'Download')}
          </Button>
        </li>
      ))}
    </ul>
  )
}
